import { calculateCornerAngleInDegrees } from './calculateCornerAngleInDegrees';
import { getNextEdgeIndex } from './getNextEdgeIndex';

import { convertFromRadiansToDegree } from '~/core/helpers';
import { DrawingEdge, DrawingShape } from '~/core/models';

export const getCornerAndOrientationAngles = (
  shape: DrawingShape,
  edge: DrawingEdge,
  edgeIndex: number
) => {
  // some preliminary math for the radii and edge calculations (angle relative to x axis = orientation
  const { dirVec } = edge;
  const angleBetweenVectAndX = Math.atan2(dirVec.y, dirVec.x);
  const orientationAngle = Math.round(
    convertFromRadiansToDegree(angleBetweenVectAndX)
  );

  const nextEdgeIndex = getNextEdgeIndex(shape, edgeIndex);

  // angle between the two adjacent edges
  const angleBetweenNextVectAndX = Math.atan2(
    shape.drawingEdges[nextEdgeIndex].dirVec.y,
    shape.drawingEdges[nextEdgeIndex].dirVec.x
  );
  const cornerAngleInRadians =
    Math.PI - (angleBetweenVectAndX - angleBetweenNextVectAndX);

  const cornerAngleInDegrees =
    calculateCornerAngleInDegrees(cornerAngleInRadians);

  return {
    orientationAngle,
    cornerAngleInDegrees,
  };
};
